import { formatNumber } from '@/utils'
import { StatTileGrid } from '../shared'

interface AnomaliesSummaryProps {
  totalTransactions: number
  categoryCount: number
  categoriesWithOutliers: number
  outlierCount: number
}

const HERO_TILE = {
  valueSize: 'lg',
  className: 'px-6 py-5',
} as const

export function AnomaliesSummary({
  totalTransactions,
  categoryCount,
  categoriesWithOutliers,
  outlierCount,
}: AnomaliesSummaryProps) {
  const outlierCategoryShare =
    categoryCount > 0 ? categoriesWithOutliers / categoryCount : 0
  const outlierTransactionShare =
    totalTransactions > 0 ? outlierCount / totalTransactions : 0

  const tiles = [
    {
      ...HERO_TILE,
      label: 'Categories analyzed',
      value: formatNumber(categoryCount),
      sub: `Across ${formatNumber(totalTransactions)} transactions`,
    },
    {
      ...HERO_TILE,
      label: 'Categories with outliers',
      value: formatNumber(categoriesWithOutliers),
      sub: `${formatNumber(outlierCategoryShare, { style: 'percent' })} of analyzed categories`,
    },
    {
      ...HERO_TILE,
      label: 'Outliers',
      value: formatNumber(outlierCount),
      sub: `${formatNumber(outlierTransactionShare, { style: 'percent' })} of all transactions`,
    },
  ]

  return <StatTileGrid tiles={tiles} columns={3} className="border-b" />
}
